export function clean<T extends { __typename?: string }>(data: T) {
    const returnData = {} as T;
    if (data?.__typename) delete data.__typename;
    const invalidData = ['containers', 'tags', 'triggers', 'updatedAt', 'updatedBy', 'purposes'];
    Object.keys(data).forEach(key => {
        if (!invalidData.includes(key)) returnData[key] = data[key];
    });
    return returnData;
}
